export { default } from './Favorite';
